<script setup lang="ts">
import { WsBadge } from '@mfl/common-components';
</script>

<template>
  <WsBadge label="BETA" aid="BETA_BADGE" />
</template>
